module.exports = __webpack_public_path__ + "img/Roboto-Thin.bdd892c.svg";